module.exports = __webpack_public_path__ + "static/woman-research-square.9fe21567.jpg";